{
    "coordinates": [
        38.64507542926481,
        -97.1857868389542
    ],
    "tooltip": "Elmo",
    "title": "Wellington Formation (Elmo Fossil Site)",
    "country": "United States",
    "period": "Permian"
}
